import { render, staticRenderFns } from "./ObjectivesTable.vue?vue&type=template&id=f878c2ce"
import script from "./ObjectivesTable.vue?vue&type=script&lang=js"
export * from "./ObjectivesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports